import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import ui from '@/store/ui'
import currentPage from '@/store/current-page'
import responsive from '@/store/responsive'
import fractions from '@/store/fractions'
import commerce from '@/store/commerce'
import checkout from '@/store/checkout'
import favorites from '@/store/favorites'
import productVariants from '@/store/product-variants'
import myMachines from '@/store/my-machines'
import myInvoiceHistory from '@/store/my-invoice-history'
import myUsers from '@/store/my-users'
import myShoppingLists from '@/store/my-shopping-lists'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ['ui.isCartDocked', 'ui.isCartOpen', 'ui.useVat', 'ui.hasAcceptedCookies', 'ui.shownMessages', 'ui.previousMarket', 'ui.showDesktopFilter']
    }),
    createPersistedState({
      storage: window.sessionStorage,
      paths: [
        'checkout.checkout',
        'checkout.isOrderRequestVisitor',
        'checkout.activeSteps',
        'favorites.favoriteVehicles',
        'ui.useListView',
        'ui.forceView',
        'myMachines.currentMachine',
        'myMachines.currentMachineOwner',
        'myMachines.globalMachineOwnerSelection',
        'myMachines.globalMachineSelection',
        'myInvoiceHistory.currentInvoice',
        'myUsers.currentUser',
        'myShoppingLists.selectedShoppingListId'
      ]
    })
  ],
  modules: {
    ui,
    currentPage,
    responsive,
    commerce,
    fractions,
    checkout,
    favorites,
    productVariants,
    myMachines,
    myInvoiceHistory,
    myUsers,
    myShoppingLists
  }
})

const urlParams = new URLSearchParams(window.location.search)
const vat = urlParams.get('vat')
const view = urlParams.get('view')

if (vat && (vat === '0' || vat === '1')) {
  store.commit('ui/toggle_value', { key: 'useVat', data: vat === '1' })
}

if (view && (view.toLowerCase() === 'grid' || view.toLowerCase() === 'list')) {
  store.commit('ui/toggle_value', { key: 'forceView', data: view.toLowerCase() })
} else {
  store.commit('ui/toggle_value', { key: 'forceView', data: null })
}

export default store
